import { ref } from 'vue'

// Always dark mode — no theme switching
const isDark = ref(true)

function updateDOM() {
  document.documentElement.classList.add('dark')
}

// Initialize theme on app start — always dark
function initTheme() {
  updateDOM()
}

export function useDarkMode() {
  return {
    isDark,
    initTheme
  }
}
